var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlotExam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_x32_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M149.193,103.525c15.994,0,28.964-12.97,28.964-28.972V28.964C178.157,12.97,165.187,0,149.193,0 C133.19,0,120.22,12.97,120.22,28.964v45.589C120.22,90.556,133.19,103.525,149.193,103.525z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M362.815,103.525c15.994,0,28.964-12.97,28.964-28.972V28.964C391.78,12.97,378.81,0,362.815,0 c-16.003,0-28.972,12.97-28.972,28.964v45.589C333.843,90.556,346.813,103.525,362.815,103.525z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.164,41.287h-17.925v33.266c0,30.017-24.415,54.431-54.423,54.431c-30.017,0-54.431-24.414-54.431-54.431 V41.287H203.615v33.266c0,30.017-24.414,54.431-54.422,54.431c-30.018,0-54.432-24.414-54.432-54.431V41.287H76.836 c-38.528,0-69.763,31.235-69.763,69.763v331.187C7.073,480.765,38.308,512,76.836,512h358.328 c38.528,0,69.763-31.235,69.763-69.763V111.05C504.927,72.522,473.691,41.287,435.164,41.287z M470.982,442.237 c0,19.748-16.07,35.818-35.818,35.818H76.836c-19.749,0-35.818-16.07-35.818-35.818V155.138h429.964V442.237z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.676,
    y: 377.571,
    className: "st0",
    width: 56.727,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.676,
    y: 289.65,
    className: "st0",
    width: 56.727,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.765,
    y: 377.571,
    className: "st0",
    width: 56.718,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.765,
    y: 289.65,
    className: "st0",
    width: 56.718,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.517,
    y: 201.73,
    className: "st0",
    width: 56.718,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.597,
    y: 201.73,
    className: "st0",
    width: 56.735,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.597,
    y: 289.65,
    className: "st0",
    width: 56.735,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.517,
    y: 377.571,
    className: "st0",
    width: 56.718,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.517,
    y: 289.65,
    className: "st0",
    width: 56.718,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.597,
    y: 377.571,
    className: "st0",
    width: 56.735,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.676,
    y: 201.73,
    className: "st0",
    width: 56.727,
    height: 56.727
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95.765,
    y: 201.73,
    className: "st0",
    width: 56.718,
    height: 56.727
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlotExam);
export default __webpack_public_path__ + "static/media/slot_exam.e7c1315d4929bb64451e8f22f1d781ad.svg";
export { ForwardRef as ReactComponent };